import { Component } from 'react';
import styles from '../../styles/home/tabs.scss';
import cx from 'classnames';
import Sticky from '../ui/sticky';

interface Tab {
  label: string;
  key: string;
  scrollId: string;
}

interface Props {
  tabs: Tab[];
  sectionId: string;
  currentSelectedKey: string;
  tabSectionId: string;
  onTabClick: any;
}

class Tabs extends Component<Props, any> {
  public render() {
    const {
      tabs,
      onTabClick,
      sectionId,
      currentSelectedKey,
      tabSectionId,
    } = this.props;
    return (
      <Sticky
        hideAfter={sectionId}
        disableDesktop={true}
        fullWidth={true}
        hideAfterOffset={126}
        noPadding={true}
      >
        <ul className={cx(styles['tab-container'])} onClick={onTabClick}>
          {tabs.map(tab => {
            const { label, key, scrollId } = tab;
            const isSelectedTab = currentSelectedKey === key;
            return (
              <li
                className={cx('inline-block', 'text--md', 'font--bold', {
                  [styles['selected']]: isSelectedTab,
                  'font--blue': isSelectedTab,
                })}
                data-key={tabSectionId}
                data-value={key}
                data-scrollid={scrollId}
                key={label}
              >
                {label}
              </li>
            );
          })}
        </ul>
      </Sticky>
    );
  }
}

export default Tabs;



// WEBPACK FOOTER //
// ./components/home/tabs.tsx